import React, { useState, useEffect, useContext } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Typography, Grid, Stack, Box, Divider } from "@mui/material"
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone"
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone"
import BackdropContext from "../../../context/BackdropContext"
import StateContext from "../../../context/StateContext"
import CurrentChatMobile from "./CurrentChatMobile"
import { F_TRADING_CHAT_DETAIL } from "../../../constants/routes"

const Chat = ({ setSnackbarMsg }) => {
  const { backdropOpen, openBackdrop, closeBackdrop } = useContext(BackdropContext)
  const [currentChat, setCurrentChat] = useState(null)

  const navigate = useNavigate()
  const location = useLocation()

  const { ledgerList, ledgerLoading } = useContext(StateContext)
  const chats = ledgerList.filter((e) => e.status === "matched" || e.status === "finished")

  const loading = ledgerLoading

  useEffect(() => {
    if (loading) {
      openBackdrop()
    } else {
      if (backdropOpen) {
        closeBackdrop()
      }
    }
  }, [loading, openBackdrop, backdropOpen, closeBackdrop])

  // todo better implementation needed, this is a hack
  return currentChat && location.search === "?detail" ? (
    <CurrentChatMobile currentChat={currentChat} setCurrentChat={setCurrentChat} setSnackbarMsg={setSnackbarMsg} />
  ) : (
    <>
      <Grid container direction="column" justifyContent="space-between" sx={{ height: "100%" }}>
        <Grid item xs="auto">
          <Typography align="center" variant="h5" sx={{ color: "secondary.main", mb: 1 }}>
            Chat
          </Typography>
          <Divider flexItem />
        </Grid>

        <Grid item xs>
          <Stack>
            {chats.map((chat) => (
              <Box
                key={chat.id}
                sx={{
                  cursor: "default",
                  height: "6vh",
                  lineHeight: "6vh",
                  px: 1,
                  my: "1vh",
                  borderTopRightRadius: "38px",
                  borderBottomRightRadius: "38px",
                  color: chat.status === "matched" ? "inherit" : "grey",
                  // textDecoration: c?.CID === currentChat?.CID ? "underline" : "inherit",
                  // backgroundColor: chat.id === currentChat?.id ? "#ebebeb" : "inherit",
                  overflow: "hidden",
                }}
                onClick={() => {
                  navigate(F_TRADING_CHAT_DETAIL)
                  setCurrentChat(chat)
                }}>
                {chat.status === "matched" ? (
                  <ChatTwoToneIcon sx={{ color: "primary.main", verticalAlign: "middle", mr: 1 }} />
                ) : (
                  <CheckBoxTwoToneIcon sx={{ color: "inherit", verticalAlign: "middle", mr: 1 }} />
                )}
                {chat.book.title}
              </Box>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </>
  )
}

export default Chat
